import React from "react";
// import ActionButton from "../partials/ActionButton";
// import StagesManager from "../StagesManager";
// import FormViewer from "../FormViewer";
// import ViewSwitcher from "../ViewSwitcher";
// import ViewsMenu from "../header/ViewsMenu";
import { checkTranslation, chooseFontColor, imageAddress, textVariableReplacer, translate } from "../../utils/useful";
// import ButtonAnimated from "../buttons/ButtonAnimated";
import HttpServices from "../../utils/Http.services";
// import RecordViewerModal from "../../modals/RecordViewerModal";
// import { saveAs } from 'file-saver';
// import ViewSwitcherWidget from "./ViewSwitcherWidget";
import importedIcons from "../inputs/icons";

class DashboardsWidget extends React.Component {
    state = {

        limit: 12,
        skip: 0,
        // currentView: "table",

        category: [
            { bg: "bg-red-300", name: "All", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "bg-red-300", name: "Pending", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Exercise", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#99FFFF", name: "Open", title: "Reading Book", des: "meeting Attend a business meeting", title1: "Painting", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#DF73FF", name: "Closed", title: "Attend a business meeting ...", des: "choose the best option and create a pleasant shopping experience. .", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },

        ],
        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.edit },
            changeStage: { key: "changeStage", label: '{{lang}}Change Stage', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "changeRecordStageModal", icon: importedIcons.changeStage },
            doneTask: { key: "doneTask", label: '{{lang}}DoneTask', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "doneTask", icon: importedIcons.changeStage },
            nextStage: { key: "nextStage", label: '{{lang}}Next Stage', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "nextRecordStage", icon: importedIcons.changeStage },

        },
        headers: [],
        currentDashboard: { _id: 'default', mode: "dashboard", name: "Default" },
        dashboards:[],

    }


    componentDidMount() {

        this.setState({ currentIndex: 0, currentItem: this.state.category[0] })
        this.init()
    }

    doneTask = (info, extra) => {
        // console.log('doneee', info, extra)
        let body = { _id: info._id }
        HttpServices.request('doneTask', body, (fetchResult, fetchError) => {
            if (fetchError) { return }
            // console.log('done', fetchResult)
        })
    }

    init() {

        let data = { ...this.props.data }
        this.setState({ information: data })
        let body = { collection: data.collection }

        this.setState({ isLoading: true })

        // this.fetchDashboards()

        HttpServices.request('getMyDashboards', {}, (fetchResult, fetchError) => {
            this.setState({ isLoading: false })
            if (fetchError) {
                this.setState({ pageStatus: 404 })
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            let dashboards = []
            if (fetchResult.info) {
                dashboards = fetchResult.info
            }
            this.setState({ pageStatus: 200, dashboards }, () => {
                this.setState({ currentDashboard: this.state.dashboards[0] })
                // let initTab = this.state.tabs[0]
                // this.stageManager.changeStage(initTab.key)
                // this.setState({ currentTab: initTab.key })
            })
        })

    }


    functionsHandler = (type, name, data, extra, info) => {
        // console.log("functionsHandler")
        // console.log(type, name, data, extra)

        // if (!this.props.userView) {

        // console.log("functionsHandler", name)

        if (this[name]) {
            this[name](data, extra, info)
        } else {
            if (this.props.functionsHandler) {
                this.props.functionsHandler(type, name, data, extra, info)
            }
        }
        // }
        // else {
        //     console.log("functionsHandlerptop", this.props)
        //     console.log("functionsHandlerstate", this.state)
        // }
    }





    openWindow = (prop, extra, info) => {
        // console.log('openWindow', prop, extra, info)
        // console.log('this.props.baseUrl', this.props.baseUrl)
        let newLink = this.props.baseUrl.splice(2)
        // return
        newLink.push(info.page)
        newLink.push(prop._id)
        // return
        // console.log('widgettttap', this.props.applet)
        // console.log('newLink', newLink)

        // return
        this.props.changeWindowLink(newLink)


    }
    postDashboard = (_id, name, pages, cb) => {
        let data = {
            _id: _id,
            name: name,
            // type: 'page',
            page: pages,
        }
        let isEditing = data._id ? true : false
        let address = 'postDashboard'
        // data.page = this.props.page?.key
        this.setState({ isPostingData: true })
        for (const [key, value] of Object.entries(data)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                delete data[key]
            }
        }
        // data.frame = this.state.currentFrame?._id
        // data.features = this.props.applet.features
        data.name = name
        // return
        HttpServices.request(address, data, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
                return
            }
            let dashboards = this.state.dashboards ?? []
            dashboards.push(fetchResult.info)
            this.setState({ dashboards })
            cb(fetchResult)
        })
    }


    openDashboards = () => {
        let path = []
        path.push('settings')
        path.push('dashboards')
        this.props.addNewWindow('', { path: path, postDashboard: this.postDashboard })
    }
    goToDashboardPage = (item) => {
        let path = []
        path.push('settings')
        path.push('dashboards')
        path.push(item._id)
        this.props.addNewWindow('', { path: path, postDashboard: this.postDashboard })
        // this.props.addNewWindow()
    }

    addNewDashboard = () => {
        let path = []
        path.push('settings')
        path.push('dashboards')
        path.push('new')
        this.props.addNewWindow('', { path: path, postDashboard: this.postDashboard })
    }
    changeDashboard = (prop) => {
        let currentDashboard = this.state.currentDashboard
        if (prop == 'default') {
            currentDashboard = this.state.dashboards[0]
        }
        else {
            currentDashboard = prop
        }
        this.setState({ currentDashboard })
    }

    render() {

        let colors = {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`

        let view = this.props.data?.view ?? {}
        view.type = this.props.data?.type ?? 'table'
        // variables.frameId = this.state.currentRelevantTab ?? this.props.page?._id
        // variables.currentItem = this.state.relevantCurrentItem ?? this.state.currentItem


        return (
            <div className=" w-100 h-100 " >
                <div className=" flexc py-2 my-2 px-4 position-sticky top-0 zindex-1" style={{ backgroundColor: '#f6f6f6', }}>
                    <button onClick={() => { this.openDashboards() }}>
                        <p className="text-big text-bold mrd-4">{translate("Dashboards")}</p>
                    </button>
                    <div className="flexc sc-gray2 py-1" style={{ overflowX: 'auto' }}>
                        <button onClick={() => this.addNewDashboard()} className="mrd-3 p-1" style={{ background: '#eee', borderRadius: 30 }}>
                            <img src="/assets/icons/plus-gray.svg" width={22} className="flexcc" />
                        </button>
                        {/* <button onClick={() => this.changeDashboard('default')} className={"mrd-3 br-8 px-3 py-2" + (this.state.currentDashboard._id == 'default' ? '' : '')} style={{ background: this.state.currentDashboard._id == 'default' ? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))' : 'linear-gradient(to right, #eee, #eee)', }}>
                            <p className={" flexcc weight-600 text-smaller  " + (this.state.currentDashboard._id == 'default' ? 'white' : 'main-c7')}>{translate('Default')}</p>
                        </button> */}
                        {/* {console.log('this.state.dashboards', this.state.dashboards)} */}
                        {this.state.dashboards.map((item, index) => {
                            return (
                                <button onClick={() => this.changeDashboard(item)} key={index} className={"mrd-3 br-8 px-3 py-2" + (this.state.currentDashboard._id == item._id ? '' : '')} style={{ background: this.state.currentDashboard._id == item._id ? 'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))' : 'linear-gradient(to right, #eee, #eee)', }}>
                                    <div className="flexcb">
                                        <p className={" flexcc weight-600 text-smaller text-uppercase " + (this.state.currentDashboard._id == item._id ? 'white' : 'main-c7')}>{checkTranslation(item.name)}</p>
                                        {(this.state.currentDashboard._id == item._id) &&
                                            <button className="mld-3" onClick={() => { this.goToDashboardPage(item) }}>
                                                <img src="/assets/icons/edit-white.svg" width={15} className="flexcc" />
                                            </button>
                                        }
                                    </div>
                                </button>
                            )
                        })}
                    </div>
                </div>
            </div >
        )
    }
}



export default DashboardsWidget;